import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3e9f2db6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No se dejaron comentarios de NPS ")
const _hoisted_2 = {
  key: 0,
  class: "personName p-p-1"
}
const _hoisted_3 = {
  key: 1,
  class: "comments p-p-1"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-ssm no-column-header",
    responsiveLayout: "scroll",
    value: _ctx.rows,
    scrollable: true,
    scrollHeight: "37.5rem"
  }, {
    empty: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field,
          style: _normalizeStyle(col.field === _ctx.ColumnFields.Student
      ? 'flex: 0 0 25%;'
      : col.field === _ctx.ColumnFields.Comments
        ? 'flex: 0 0 65%;'
        : 'flex: 0 0 10%; justify-content: center;'
    )
        }, {
          body: _withCtx(({ data }) => [
            (col.field === _ctx.ColumnFields.Student)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(data.personName), 1))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.Comments)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(data.comments || '-'), 1))
              : _createCommentVNode("", true),
            (col.field === _ctx.ColumnFields.Rating)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(['rating p-p-1', data.rating && data.rating >= 4.7 ? 'text-good' : 'text-problem'])
                }, _toDisplayString(data.rating), 3))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["style"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}